import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import React from "react";
import {
  ButtonContainer,
  FormContainer,
  HeaderRow,
  OuterContainer,
  PageTitle,
  StepContent,
  StepIndicator,
  StepLine,
  StepNumber,
  StepTitle,
  StepWrapper,
  StyledBenevvSubmitField,
} from "./MultiStepForm.styles";

export interface StepDefinition {
  title: string;
  render: (disabled: boolean) => React.ReactNode;
  validate: () => boolean;
}

interface MultiStepFormProps {
  title: string;
  steps: StepDefinition[];
  onBack: () => void;
  onSubmit: () => void;
  submitLabel?: string;
}

const MultiStepForm: React.FC<MultiStepFormProps> = ({
  title,
  steps,
  onBack,
  onSubmit,
  submitLabel = "Submit",
}) => {
  const isStepComplete = (idx: number) => steps[idx].validate();

  const allComplete = steps.every((_, i) => isStepComplete(i));

  return (
    <OuterContainer>
      <FormContainer
        onSubmit={(e) => {
          e.preventDefault();
          if (allComplete) onSubmit();
        }}
      >
        <HeaderRow>
          <ArrowBackIosIcon fontSize="large" onClick={onBack} />
          <PageTitle>{title}</PageTitle>
        </HeaderRow>

        {steps.map((step, idx) => {
          const prevIncomplete = steps
            .slice(0, idx)
            .some((_, i) => !isStepComplete(i));
          const disabled = prevIncomplete;
          const complete = isStepComplete(idx);

          return (
            <StepWrapper key={idx}>
              <StepIndicator>
                <StepNumber isComplete={complete}>{idx + 1}</StepNumber>
                {idx !== steps.length - 1 && <StepLine />}
              </StepIndicator>

              <StepContent>
                <StepTitle>{step.title}</StepTitle>
                <div style={{ opacity: disabled ? 0.5 : 1 }}>
                  {step.render(disabled)}
                </div>
              </StepContent>
            </StepWrapper>
          );
        })}

        <ButtonContainer>
          <StyledBenevvSubmitField
            value={submitLabel}
            // disabled={!allComplete}
          />
        </ButtonContainer>
      </FormContainer>
    </OuterContainer>
  );
};

export default MultiStepForm;
